/**
 * admin translations
 * Auto-split from staticTranslations.ts
 */

// ─── All sections combined ─────────────────────────────────
// ─── Admin UI ─────────────────────────────────────────
export const admin = {
  en: {
    // Blog Management
    manageTags: "Manage Tags", newPost: "New Post", backToList: "Back to list",
    newTagPlaceholder: "New tag name...", addTag: "Add", noPostsYet: "No posts yet. Create your first post!",
    published: "Published", draft: "Draft", deletePost: "Delete post?", hide: "Hide", publish: "Publish",
    tagCreated: "Tag created", tagDeleted: "Tag deleted", postDeleted: "Post deleted", statusUpdated: "Status updated",
    deleteTag: "Delete tag", confirmDeleteTag: "Delete tag",
    // Slider
    sliderManagement: "Slider Management", addSlide: "Add slide", saveChanges: "Save changes",
    slideNumber: "Slide", active: "Active", image: "Image", uploadImage: "Upload image",
    title: "Title", titlePlaceholder: "Slide title", subtitle: "Subtitle", subtitlePlaceholder: "Subtitle",
    buttonText: "Button text", buttonTextPlaceholder: "e.g.: View collection",
    linkType: "Link type", category: "Category", externalLink: "External link", internalPage: "Internal page",
    selectCategory: "Select category", enterUrl: "URL address", selectPage: "Select page",
    noSlides: "No slides. Add a first slide to get started.",
    slidesSaved: "Slides saved successfully", slideSaveError: "Error saving slides",
    newSlideAdded: "New slide added", slideDeleted: "Slide deleted",
    imageUploaded: "Image uploaded successfully", imageUploadError: "Error uploading image",
    sliderLoadError: "Error loading slider data",
    // Repair Management
    smsBalance: "SMS balance", messages: "messages",
    searchPlaceholder: "Search by order number, name, phone...",
    addOrder: "Add order/repair", newOrder: "New order/repair", editOrder: "Edit order/repair",
    orderNumber: "Order number", rescan: "Rescan", orderExists: "This order number already exists.",
    guestCustomer: "Guest customer", registeredCustomer: "Registered customer",
    guestPhone: "Guest phone number *", guestPhoneNote: "Customer can track order via phone number with OTP code",
    searchCustomer: "Search customer", searchCustomerPlaceholder: "Search by name, phone or email...",
    noCustomersFound: "No customers found", titleField: "Title *", description: "Description",
    status: "Status", cancel: "Cancel", save: "Save",
    noOrdersFound: "No orders matching search", noOrders: "No orders/repairs at the moment",
    guest: "Guest", phone: "Phone", email: "Email", customer: "Customer",
    created: "Created", updated: "Updated", markDelivered: "Mark as delivered",
    alreadyDelivered: "Order already marked as delivered", statusDelivered: "Status changed to delivered",
    fillRequired: "Please fill in all required fields", orderAdded: "Order added successfully",
    orderUpdated: "Order updated successfully", orderDeleted: "Order deleted successfully",
    deleteOrder: "Delete this order?", orderAddError: "Error adding order", orderUpdateError: "Error updating order",
    orderDeleteError: "Error deleting order", dataLoadError: "Error loading data",
    smsError: "Order updated but SMS failed", smsSent: "SMS sent to customer", smsErrorMsg: "SMS error",
    orderExistsError: "This order number already exists",
    // FAQ
    faqPage: "FAQ - FAQ Page", faqProduct: "FAQ - Product Page",
    // Profile nav
    main: "Main", orders: "Orders", favorites: "Favorites", tracking: "Tracking",
    more: "More", myMessages: "My Messages", moreOptions: "More options",
    contactMessages: "Contact messages", sendMessages: "Send messages", smsMessages: "SMS messages",
    blogManagement: "Blog management", sliderManagementNav: "Slider management", promoBanner: "Promo banner",
    faq: "FAQ", repairManagement: "Repair management", userManagement: "User management",
    menuSettings: "Menu settings", searchSettings: "Search settings", botSettings: "Bot settings",
    colorHelper: "Help - Colors", accessibilityReport: "Accessibility report",
    communication: "Communication", contentManagement: "Content management", operations: "Operations",
    settingsAndTools: "Settings & tools", backToSite: "Back to site", disconnect: "Disconnect",
    hello: "Hello",
    // Repair statuses
    statusPending: "Pending", statusInRepair: "In repair", statusCompleted: "Completed",
    statusWaitingInStore: "Waiting in store", statusShipped: "Shipped",
    statusDeliveredLabel: "Delivered", statusCancelled: "Cancelled",
    addRepair: "Add order",
  },
  ru: {
    manageTags: "Управление тегами", newPost: "Новый пост", backToList: "Назад к списку",
    newTagPlaceholder: "Название нового тега...", addTag: "Добавить", noPostsYet: "Пока нет постов. Создайте первый пост!",
    published: "Опубликовано", draft: "Черновик", deletePost: "Удалить пост?", hide: "Скрыть", publish: "Опубликовать",
    tagCreated: "Тег создан", tagDeleted: "Тег удалён", postDeleted: "Пост удалён", statusUpdated: "Статус обновлён",
    deleteTag: "Удалить тег", confirmDeleteTag: "Удалить тег",
    sliderManagement: "Управление слайдером", addSlide: "Добавить слайд", saveChanges: "Сохранить",
    slideNumber: "Слайд", active: "Активен", image: "Изображение", uploadImage: "Загрузить изображение",
    title: "Заголовок", titlePlaceholder: "Заголовок слайда", subtitle: "Подзаголовок", subtitlePlaceholder: "Подзаголовок",
    buttonText: "Текст кнопки", buttonTextPlaceholder: "Напр.: Смотреть коллекцию",
    linkType: "Тип ссылки", category: "Категория", externalLink: "Внешняя ссылка", internalPage: "Внутренняя страница",
    selectCategory: "Выберите категорию", enterUrl: "URL", selectPage: "Выберите страницу",
    noSlides: "Нет слайдов. Добавьте первый слайд.",
    slidesSaved: "Слайды сохранены", slideSaveError: "Ошибка сохранения", newSlideAdded: "Добавлен новый слайд",
    slideDeleted: "Слайд удалён", imageUploaded: "Изображение загружено", imageUploadError: "Ошибка загрузки",
    sliderLoadError: "Ошибка загрузки данных",
    smsBalance: "Баланс SMS", messages: "сообщений",
    searchPlaceholder: "Поиск по номеру, имени, телефону...",
    addOrder: "Добавить заказ/ремонт", newOrder: "Новый заказ/ремонт", editOrder: "Редактировать заказ/ремонт",
    orderNumber: "Номер заказа", rescan: "Сканировать заново", orderExists: "Этот номер заказа уже существует.",
    guestCustomer: "Гость", registeredCustomer: "Зарегистрированный",
    guestPhone: "Телефон гостя *", guestPhoneNote: "Клиент сможет отслеживать заказ по номеру телефона с OTP",
    searchCustomer: "Поиск клиента", searchCustomerPlaceholder: "Поиск по имени, телефону или email...",
    noCustomersFound: "Клиенты не найдены", titleField: "Название *", description: "Описание",
    status: "Статус", cancel: "Отмена", save: "Сохранить",
    noOrdersFound: "Заказы не найдены", noOrders: "Нет заказов/ремонтов",
    guest: "Гость", phone: "Телефон", email: "Email", customer: "Клиент",
    created: "Создан", updated: "Обновлён", markDelivered: "Отметить как доставлен",
    alreadyDelivered: "Заказ уже отмечен как доставлен", statusDelivered: "Статус изменён на доставлен",
    fillRequired: "Заполните все обязательные поля", orderAdded: "Заказ добавлен",
    orderUpdated: "Заказ обновлён", orderDeleted: "Заказ удалён",
    deleteOrder: "Удалить этот заказ?", orderAddError: "Ошибка добавления", orderUpdateError: "Ошибка обновления",
    orderDeleteError: "Ошибка удаления", dataLoadError: "Ошибка загрузки данных",
    smsError: "Заказ обновлён, но SMS не отправлено", smsSent: "SMS отправлено клиенту", smsErrorMsg: "Ошибка SMS",
    orderExistsError: "Этот номер заказа уже существует",
    faqPage: "FAQ - страница FAQ", faqProduct: "FAQ - страница товара",
    main: "Главная", orders: "Заказы", favorites: "Избранное", tracking: "Отслеживание",
    more: "Ещё", myMessages: "Мои сообщения", moreOptions: "Дополнительно",
    contactMessages: "Сообщения контакта", sendMessages: "Отправка сообщений", smsMessages: "SMS сообщения",
    blogManagement: "Управление блогом", sliderManagementNav: "Управление слайдером", promoBanner: "Промо баннер",
    faq: "FAQ", repairManagement: "Управление ремонтами", userManagement: "Управление пользователями",
    menuSettings: "Настройки меню", searchSettings: "Настройки поиска", botSettings: "Настройки бота",
    colorHelper: "Помощь - цвета", accessibilityReport: "Отчёт о доступности",
    communication: "Коммуникация", contentManagement: "Управление контентом", operations: "Операции",
    settingsAndTools: "Настройки и инструменты", backToSite: "Вернуться на сайт", disconnect: "Выйти",
    hello: "Здравствуйте",
    statusPending: "Ожидает", statusInRepair: "В ремонте", statusCompleted: "Завершён",
    statusWaitingInStore: "Ожидает в магазине", statusShipped: "Отправлен",
    statusDeliveredLabel: "Доставлен", statusCancelled: "Отменён",
    addRepair: "Добавить заказ",
  },
  ar: {
    manageTags: "إدارة الوسوم", newPost: "منشور جديد", backToList: "العودة للقائمة",
    newTagPlaceholder: "اسم وسم جديد...", addTag: "إضافة", noPostsYet: "لا توجد منشورات بعد. أنشئ أول منشور!",
    published: "منشور", draft: "مسودة", deletePost: "حذف المنشور؟", hide: "إخفاء", publish: "نشر",
    tagCreated: "تم إنشاء الوسم", tagDeleted: "تم حذف الوسم", postDeleted: "تم حذف المنشور", statusUpdated: "تم تحديث الحالة",
    deleteTag: "حذف الوسم", confirmDeleteTag: "حذف الوسم",
    sliderManagement: "إدارة الشرائح", addSlide: "إضافة شريحة", saveChanges: "حفظ التغييرات",
    slideNumber: "شريحة", active: "نشط", image: "صورة", uploadImage: "رفع صورة",
    title: "العنوان", titlePlaceholder: "عنوان الشريحة", subtitle: "العنوان الفرعي", subtitlePlaceholder: "العنوان الفرعي",
    buttonText: "نص الزر", buttonTextPlaceholder: "مثال: عرض المجموعة",
    linkType: "نوع الرابط", category: "فئة", externalLink: "رابط خارجي", internalPage: "صفحة داخلية",
    selectCategory: "اختر فئة", enterUrl: "عنوان URL", selectPage: "اختر صفحة",
    noSlides: "لا توجد شرائح. أضف أول شريحة للبدء.",
    slidesSaved: "تم حفظ الشرائح", slideSaveError: "خطأ في الحفظ", newSlideAdded: "تمت إضافة شريحة جديدة",
    slideDeleted: "تم حذف الشريحة", imageUploaded: "تم رفع الصورة", imageUploadError: "خطأ في رفع الصورة",
    sliderLoadError: "خطأ في تحميل البيانات",
    smsBalance: "رصيد SMS", messages: "رسائل",
    searchPlaceholder: "بحث برقم الطلب، الاسم، الهاتف...",
    addOrder: "إضافة طلب/إصلاح", newOrder: "طلب/إصلاح جديد", editOrder: "تعديل الطلب/الإصلاح",
    orderNumber: "رقم الطلب", rescan: "إعادة المسح", orderExists: "رقم الطلب هذا موجود بالفعل.",
    guestCustomer: "عميل زائر", registeredCustomer: "عميل مسجل",
    guestPhone: "رقم هاتف الزائر *", guestPhoneNote: "يمكن للعميل تتبع الطلب عبر رقم الهاتف باستخدام رمز OTP",
    searchCustomer: "بحث عن عميل", searchCustomerPlaceholder: "بحث بالاسم أو الهاتف أو البريد...",
    noCustomersFound: "لم يتم العثور على عملاء", titleField: "العنوان *", description: "الوصف",
    status: "الحالة", cancel: "إلغاء", save: "حفظ",
    noOrdersFound: "لم يتم العثور على طلبات", noOrders: "لا توجد طلبات/إصلاحات حالياً",
    guest: "زائر", phone: "هاتف", email: "بريد إلكتروني", customer: "عميل",
    created: "أُنشئ", updated: "حُدّث", markDelivered: "تحديد كمُسلَّم",
    alreadyDelivered: "الطلب مُحدد كمُسلَّم بالفعل", statusDelivered: "تم تغيير الحالة إلى مُسلَّم",
    fillRequired: "يرجى ملء جميع الحقول المطلوبة", orderAdded: "تمت إضافة الطلب",
    orderUpdated: "تم تحديث الطلب", orderDeleted: "تم حذف الطلب",
    deleteOrder: "حذف هذا الطلب؟", orderAddError: "خطأ في الإضافة", orderUpdateError: "خطأ في التحديث",
    orderDeleteError: "خطأ في الحذف", dataLoadError: "خطأ في تحميل البيانات",
    smsError: "تم تحديث الطلب لكن فشل إرسال SMS", smsSent: "تم إرسال SMS للعميل", smsErrorMsg: "خطأ SMS",
    orderExistsError: "رقم الطلب هذا موجود بالفعل",
    faqPage: "الأسئلة الشائعة - صفحة FAQ", faqProduct: "الأسئلة الشائعة - صفحة المنتج",
    main: "الرئيسية", orders: "الطلبات", favorites: "المفضلة", tracking: "التتبع",
    more: "المزيد", myMessages: "رسائلي", moreOptions: "خيارات إضافية",
    contactMessages: "رسائل التواصل", sendMessages: "إرسال رسائل", smsMessages: "رسائل SMS",
    blogManagement: "إدارة المدونة", sliderManagementNav: "إدارة الشرائح", promoBanner: "شريط العروض",
    faq: "الأسئلة الشائعة", repairManagement: "إدارة الإصلاحات", userManagement: "إدارة المستخدمين",
    menuSettings: "إعدادات القائمة", searchSettings: "إعدادات البحث", botSettings: "إعدادات البوت",
    colorHelper: "مساعدة - الألوان", accessibilityReport: "تقرير إمكانية الوصول",
    communication: "التواصل", contentManagement: "إدارة المحتوى", operations: "العمليات",
    settingsAndTools: "الإعدادات والأدوات", backToSite: "العودة للموقع", disconnect: "قطع الاتصال",
    hello: "مرحباً",
    statusPending: "قيد الانتظار", statusInRepair: "قيد الإصلاح", statusCompleted: "مكتمل",
    statusWaitingInStore: "في انتظار بالمتجر", statusShipped: "تم الشحن",
    statusDeliveredLabel: "تم التسليم", statusCancelled: "ملغي",
    addRepair: "إضافة طلب",
  },
};

// ─── Admin Menu Settings ─────────────────────────────────────────
export const adminMenu = {
  en: {
    menuSettings: "Menu Settings", saveSettings: "Save Settings", searchShopify: "Search category in Shopify...",
    search: "Search", searchResults: "Search results", mainMenu: "Main Menu", featuredCategories: "Featured Categories",
    categoryFilter: "Category Filter", sections: "Sections", emptyCart: "Empty Cart",
    megaMenu: "Main Menu - Mega Menu", megaMenuDesc: "Create headings with sub-headings and categories. Drag to reorder.",
    addHeading: "Add Heading", noHeadingsYet: "No headings defined yet", clickAddHeading: "Click \"Add Heading\" to start",
    headingPlaceholder: "Heading name (e.g.: Necklaces)", megaMenuImage: "Mega menu image:",
    uploadImage: "Upload Image", createWithAI: "Create with AI", describeImage: "Describe the image you want to create...",
    createImage: "Create Image", megaMenuImageDesc: "The image will appear on the left side of the mega menu when hovering over the category",
    directLink: "Direct link to category (no dropdown):", noDirectLink: "No direct link (use sub-headings)",
    directLinkDesc: "If a direct link is selected, clicking the heading will navigate directly to the category without a dropdown",
    subHeadingPlaceholder: "Sub-heading name (e.g.: Men's Necklaces)", addSubHeading: "Add Sub-heading",
    selectCategories: "Select categories:", searchCategory: "Search category...", foundCategories: "categories found",
    noMatchingCategories: "No matching categories found", selectedCount: "selected", categories: "categories",
    featuredTitle: "Featured Categories on Homepage", featuredDesc: "Choose which categories to display in the \"Featured Categories\" section on the homepage",
    clearAll: "Clear All", selectedFeatured: "featured categories selected out of",
    filterTitle: "Filtering on Category Page", filterDesc: "Choose which categories to display in the filter menu on the products page",
    selectAll: "Select All", selectedFilter: "selected out of",
    homepageSectionsTitle: "Homepage Sections", homepageSectionsDesc: "Create product sections by category. Each section will display 4 products from the selected category.",
    addSection: "Add Section", noSectionsYet: "No sections defined yet", clickAddSection: "Click \"Add Section\" to start",
    sectionPlaceholder: "Section name (e.g.: Engagement Rings)", selectCategory: "Select category",
    sectionsCount: "sections defined", categoriesAvailable: "categories available",
    emptyCartTitle: "Empty Cart Categories", emptyCartDesc: "Choose which categories to display when the shopping cart is empty. These buttons will help customers start shopping.",
    selectedEmptyCart: "empty cart categories selected out of",
    imageUploaded: "Image uploaded successfully", imageUploadError: "Error uploading image",
    enterImageDesc: "Please enter an image description", imageCreated: "Image created successfully", imageCreateError: "Error creating image",
    titleLink: "Title link to categories (hover still opens mega menu):", noTitleLink: "No title link",
    titleLinkDesc: "Clicking the title will navigate to all products with auto-filter on selected categories, hovering will still open the mega menu",
    settingsSaved: "Settings saved successfully", settingsSaveError: "Error saving settings",
    loadError: "Error loading settings", loadMoreError: "Error loading more categories",
    searchError: "Error searching categories", loadingPublic: "Loading public categories (Admin API unavailable)",
  },
  ru: {
    menuSettings: "Настройки меню", saveSettings: "Сохранить настройки", searchShopify: "Поиск категории в Shopify...",
    search: "Поиск", searchResults: "Результаты поиска", mainMenu: "Главное меню", featuredCategories: "Избранные категории",
    categoryFilter: "Фильтр категорий", sections: "Секции", emptyCart: "Пустая корзина",
    megaMenu: "Главное меню - Mega Menu", megaMenuDesc: "Создавайте заголовки с подзаголовками и категориями. Перетащите для изменения порядка.",
    addHeading: "Добавить заголовок", noHeadingsYet: "Заголовки ещё не определены", clickAddHeading: "Нажмите \"Добавить заголовок\" чтобы начать",
    headingPlaceholder: "Название заголовка (пример: Колье)", megaMenuImage: "Изображение для мега-меню:",
    uploadImage: "Загрузить изображение", createWithAI: "Создать с AI", describeImage: "Опишите изображение, которое хотите создать...",
    createImage: "Создать изображение", megaMenuImageDesc: "Изображение будет отображаться слева в мега-меню при наведении на категорию",
    directLink: "Прямая ссылка на категорию (без выпадающего меню):", noDirectLink: "Без прямой ссылки (использовать подзаголовки)",
    directLinkDesc: "Если выбрана прямая ссылка, нажатие на заголовок перенаправит прямо на категорию без выпадающего меню",
    subHeadingPlaceholder: "Название подзаголовка (пример: Мужские колье)", addSubHeading: "Добавить подзаголовок",
    selectCategories: "Выберите категории:", searchCategory: "Поиск категории...", foundCategories: "категорий найдено",
    noMatchingCategories: "Подходящие категории не найдены", selectedCount: "выбрано", categories: "категорий",
    featuredTitle: "Избранные категории на главной", featuredDesc: "Выберите категории для секции \"Избранные категории\" на главной странице",
    clearAll: "Очистить всё", selectedFeatured: "избранных категорий выбрано из",
    filterTitle: "Фильтрация на странице категории", filterDesc: "Выберите категории для меню фильтрации на странице товаров",
    selectAll: "Выбрать всё", selectedFilter: "выбрано из",
    homepageSectionsTitle: "Секции главной страницы", homepageSectionsDesc: "Создайте секции товаров по категориям. Каждая секция покажет 4 товара из выбранной категории.",
    addSection: "Добавить секцию", noSectionsYet: "Секции ещё не определены", clickAddSection: "Нажмите \"Добавить секцию\" чтобы начать",
    sectionPlaceholder: "Название секции (пример: Обручальные кольца)", selectCategory: "Выберите категорию",
    sectionsCount: "секций определено", categoriesAvailable: "категорий доступно",
    emptyCartTitle: "Категории в пустой корзине", emptyCartDesc: "Выберите категории для отображения когда корзина пуста. Эти кнопки помогут покупателям начать покупки.",
    selectedEmptyCart: "категорий пустой корзины выбрано из",
    imageUploaded: "Изображение загружено", imageUploadError: "Ошибка загрузки изображения",
    enterImageDesc: "Введите описание изображения", imageCreated: "Изображение создано", imageCreateError: "Ошибка создания изображения",
    settingsSaved: "Настройки сохранены", settingsSaveError: "Ошибка сохранения настроек",
    loadError: "Ошибка загрузки настроек", loadMoreError: "Ошибка загрузки категорий",
    titleLink: "Ссылка заголовка на категории (hover всё ещё открывает мега-меню):", noTitleLink: "Без ссылки заголовка",
    titleLinkDesc: "Нажатие на заголовок перенаправит на все товары с авто-фильтром по выбранным категориям, наведение всё ещё откроет мега-меню",
    searchError: "Ошибка поиска категорий", loadingPublic: "Загрузка публичных категорий (Admin API недоступен)",
  },
  ar: {
    menuSettings: "إعدادات القائمة", saveSettings: "حفظ الإعدادات", searchShopify: "ابحث عن فئة في Shopify...",
    search: "بحث", searchResults: "نتائج البحث", mainMenu: "القائمة الرئيسية", featuredCategories: "الفئات المميزة",
    categoryFilter: "تصفية الفئات", sections: "الأقسام", emptyCart: "السلة فارغة",
    megaMenu: "القائمة الرئيسية - Mega Menu", megaMenuDesc: "أنشئ عناوين مع عناوين فرعية وفئات. اسحب لإعادة الترتيب.",
    addHeading: "إضافة عنوان", noHeadingsYet: "لم يتم تعريف عناوين بعد", clickAddHeading: "انقر على \"إضافة عنوان\" للبدء",
    headingPlaceholder: "اسم العنوان (مثال: قلادات)", megaMenuImage: "صورة القائمة الضخمة:",
    uploadImage: "تحميل صورة", createWithAI: "إنشاء بالذكاء الاصطناعي", describeImage: "صِف الصورة التي تريد إنشاءها...",
    createImage: "إنشاء صورة", megaMenuImageDesc: "ستظهر الصورة على الجانب الأيسر من القائمة الضخمة عند التمرير فوق الفئة",
    directLink: "رابط مباشر للفئة (بدون قائمة منسدلة):", noDirectLink: "بدون رابط مباشر (استخدم عناوين فرعية)",
    directLinkDesc: "إذا تم اختيار رابط مباشر، سيؤدي النقر على العنوان إلى الانتقال مباشرة للفئة بدون قائمة منسدلة",
    subHeadingPlaceholder: "اسم العنوان الفرعي (مثال: قلادات رجالية)", addSubHeading: "إضافة عنوان فرعي",
    selectCategories: "اختر الفئات:", searchCategory: "ابحث عن فئة...", foundCategories: "فئات تم العثور عليها",
    noMatchingCategories: "لم يتم العثور على فئات مطابقة", selectedCount: "محدد", categories: "فئات",
    featuredTitle: "الفئات المميزة في الصفحة الرئيسية", featuredDesc: "اختر الفئات التي ستظهر في قسم \"الفئات المميزة\" في الصفحة الرئيسية",
    clearAll: "مسح الكل", selectedFeatured: "فئات مميزة محددة من",
    filterTitle: "التصفية في صفحة الفئة", filterDesc: "اختر الفئات التي ستظهر في قائمة التصفية في صفحة المنتجات",
    selectAll: "تحديد الكل", selectedFilter: "محدد من",
    homepageSectionsTitle: "أقسام الصفحة الرئيسية", homepageSectionsDesc: "أنشئ أقسام منتجات حسب الفئة. كل قسم سيعرض 4 منتجات من الفئة المختارة.",
    addSection: "إضافة قسم", noSectionsYet: "لم يتم تعريف أقسام بعد", clickAddSection: "انقر على \"إضافة قسم\" للبدء",
    sectionPlaceholder: "اسم القسم (مثال: خواتم خطوبة)", selectCategory: "اختر فئة",
    sectionsCount: "أقسام محددة", categoriesAvailable: "فئات متاحة",
    emptyCartTitle: "فئات السلة الفارغة", emptyCartDesc: "اختر الفئات التي ستظهر عندما تكون سلة التسوق فارغة. ستساعد هذه الأزرار العملاء على بدء التسوق.",
    selectedEmptyCart: "فئات سلة فارغة محددة من",
    imageUploaded: "تم تحميل الصورة بنجاح", imageUploadError: "خطأ في تحميل الصورة",
    enterImageDesc: "يرجى إدخال وصف الصورة", imageCreated: "تم إنشاء الصورة بنجاح", imageCreateError: "خطأ في إنشاء الصورة",
    settingsSaved: "تم حفظ الإعدادات بنجاح", settingsSaveError: "خطأ في حفظ الإعدادات",
    loadError: "خطأ في تحميل الإعدادات", loadMoreError: "خطأ في تحميل المزيد من الفئات",
    titleLink: "رابط العنوان للفئات (التمرير يفتح القائمة الضخمة):", noTitleLink: "بدون رابط عنوان",
    titleLinkDesc: "النقر على العنوان سينتقل إلى جميع المنتجات مع تصفية تلقائية على الفئات المختارة، التمرير سيظل يفتح القائمة الضخمة",
    searchError: "خطأ في البحث عن الفئات", loadingPublic: "تحميل الفئات العامة (Admin API غير متاح)",
  },
};

// ─── Admin User Management ─────────────────────────────────────────
export const adminUsers = {
  en: {
    userManagement: "User Management", users: "users", searchPlaceholder: "Search by name or phone...",
    noUsersFound: "No users found", noName: "No name", admin: "Admin", disabled: "Disabled",
    joined: "Joined:", editDetails: "Edit details", removeAdmin: "Remove admin permissions", makeAdmin: "Make admin",
    active: "Active", editUser: "Edit User Details", editUserDesc: "Edit user details",
    firstName: "First Name", lastName: "Last Name", phone: "Phone", cancel: "Cancel", save: "Save",
    userActivated: "User activated", userDeactivated: "User deactivated", statusError: "Error updating user status",
    madeAdmin: "User is now an admin", adminRemoved: "Admin permissions removed", roleError: "Error updating user permissions",
    userUpdated: "User details updated", saveError: "Error saving changes", loadError: "Error loading users",
  },
  ru: {
    userManagement: "Управление пользователями", users: "пользователей", searchPlaceholder: "Поиск по имени или телефону...",
    noUsersFound: "Пользователи не найдены", noName: "Без имени", admin: "Админ", disabled: "Отключён",
    joined: "Присоединился:", editDetails: "Редактировать", removeAdmin: "Убрать права админа", makeAdmin: "Сделать админом",
    active: "Активен", editUser: "Редактирование пользователя", editUserDesc: "Редактируйте данные пользователя",
    firstName: "Имя", lastName: "Фамилия", phone: "Телефон", cancel: "Отмена", save: "Сохранить",
    userActivated: "Пользователь активирован", userDeactivated: "Пользователь отключён", statusError: "Ошибка обновления статуса",
    madeAdmin: "Пользователь стал админом", adminRemoved: "Права админа убраны", roleError: "Ошибка обновления прав",
    userUpdated: "Данные обновлены", saveError: "Ошибка сохранения", loadError: "Ошибка загрузки пользователей",
  },
  ar: {
    userManagement: "إدارة المستخدمين", users: "مستخدمين", searchPlaceholder: "ابحث بالاسم أو الهاتف...",
    noUsersFound: "لم يتم العثور على مستخدمين", noName: "بدون اسم", admin: "مشرف", disabled: "معطّل",
    joined: "انضم:", editDetails: "تعديل التفاصيل", removeAdmin: "إزالة صلاحيات المشرف", makeAdmin: "جعله مشرفاً",
    active: "نشط", editUser: "تعديل بيانات المستخدم", editUserDesc: "تعديل بيانات المستخدم",
    firstName: "الاسم الأول", lastName: "اسم العائلة", phone: "هاتف", cancel: "إلغاء", save: "حفظ",
    userActivated: "تم تفعيل المستخدم", userDeactivated: "تم تعطيل المستخدم", statusError: "خطأ في تحديث الحالة",
    madeAdmin: "أصبح المستخدم مشرفاً", adminRemoved: "تمت إزالة صلاحيات المشرف", roleError: "خطأ في تحديث الصلاحيات",
    userUpdated: "تم تحديث البيانات", saveError: "خطأ في الحفظ", loadError: "خطأ في تحميل المستخدمين",
  },
};

// ─── Admin Color Helper ─────────────────────────────────────────
export const adminColor = {
  en: {
    variantInfo: "Variant Information", variantInfoDesc: "Mapping of colors, fonts, and tags for use in orders and products",
    colors: "Colors", fonts: "Fonts", icons: "Icons", tags: "Tags", variants: "Variants",
    copied: "Copied", copy: "Copy", copyError: "Error copying",
    fontsDesc: "Below is the list of engraving fonts. When a customer selects a font, the font ID is sent to the Shopify order.",
    howItWorks: "How does it work?",
    fontHowTo1: "When a customer selects a font for engraving, the ID (e.g.: font-a) is sent as part of the order",
    fontHowTo2: "The Shopify order will contain the \"Font Type\" field with the font ID",
    fontHowTo3: "Use the table above to identify which font the customer selected",
    iconsDesc: "Below is the list of available icons for engraving. Products with the \"אייקון\" tag will show an icon selection option.",
    iconHowTo1: "Add the tag \"אייקון\" to the product in Shopify",
    iconHowTo2: "On the product page, an icon selection option will appear",
    iconHowTo3: "The icon the customer selected will appear in the order details with its ID",
    tagsDesc: "Below is the list of tags that can be added to products in Shopify to enable various features on the site.",
    engravingTags: "Engraving Tags",
    howToAddTag: "How to add a tag?",
    tagHowTo1: "Go to the product editor in Shopify", tagHowTo2: "Scroll to the \"Tags\" area",
    tagHowTo3: "Add the desired tag exactly as shown above", tagHowTo4: "For example: adding \"חריטה 2\" will show 2 engraving fields on the product page",
    wordsVariant: "\"Words\" Variant - Pricing by Word Count",
    wordsVariantDesc: "This variant allows setting different prices based on the number of words the customer enters for engraving. The system automatically selects the appropriate variant by word count.",
    noEngraving: "No engraving - the base price of the product", oneWord: "One word - price for single word engraving",
    twoWords: "Two words - price for two-word engraving", threeWords: "Three words - price for three-word engraving",
    howToSetup: "How to set up in Shopify?",
    setupStep1: "Go to the product editor in Shopify", setupStep2: "Scroll to the \"Variants\" area",
    setupStep3: "Add a new option named", setupStep4: "Add the values:", 
    setupStep5: "Set a different price for each variant (e.g.: 0 = ₪100, 1 = ₪120, 2 = ₪140, 3 = ₪160)",
    setupStep6: "Save the product",
    quickLinks: "Quick Links to Shopify Management", productManagement: "Product Management",
    addNewProduct: "Add New Product", collectionManagement: "Collection Management", orderManagement: "Order Management",
    attention: "Attention!",
    attentionDesc: "The system automatically selects the variant based on the number of words the customer types in the engraving field. If there's no \"Words\" variant, the price stays fixed regardless of word count.",
    usageInstructions: "Usage Instructions",
    usage1Title: "1. Adding a color to a product in Shopify",
    usage1Desc: "When adding a variant to a product, use the color names from the list above. The system will automatically recognize the color and display the correct circle.",
    usage2Title: "2. Supported color names",
    usage2Desc: "Make sure you use the exact color names from the list. For example: \"Gold 14K\" not \"14 Karat Gold\".",
    usage3Title: "3. Engraving in orders",
    usage3Desc: "When a customer orders a product with engraving, the order will contain the engraving text and the font ID. Use the \"Engraving Fonts\" tab to identify the correct font.",
    usage4Title: "4. Variant images",
    usage4Desc: "It's recommended to upload a specific image for each color variant in Shopify. The image will also be displayed in the shopping cart when the customer selects the specific color.",
  },
  ru: {
    variantInfo: "Информация о вариантах", variantInfoDesc: "Маппинг цветов, шрифтов и тегов для использования в заказах и товарах",
    colors: "Цвета", fonts: "Шрифты", icons: "Иконки", tags: "Теги", variants: "Варианты",
    copied: "Скопировано", copy: "Копировать", copyError: "Ошибка копирования",
    fontsDesc: "Ниже список шрифтов для гравировки. Когда клиент выбирает шрифт, ID шрифта отправляется в заказ Shopify.",
    howItWorks: "Как это работает?",
    fontHowTo1: "Когда клиент выбирает шрифт для гравировки, ID (например: font-a) отправляется как часть заказа",
    fontHowTo2: "Заказ в Shopify будет содержать поле \"Тип шрифта\" с ID шрифта",
    fontHowTo3: "Используйте таблицу выше чтобы определить какой шрифт выбрал клиент",
    iconsDesc: "Ниже список доступных иконок для гравировки. Для товаров с тегом \"אייקון\" отображается выбор иконки.",
    iconHowTo1: "Добавьте тег \"אייקון\" к товару в Shopify",
    iconHowTo2: "На странице товара появится выбор иконки для гравировки",
    iconHowTo3: "Выбранная клиентом иконка появится в деталях заказа с её ID",
    tagsDesc: "Ниже список тегов для добавления к товарам в Shopify для активации различных функций на сайте.",
    engravingTags: "Теги гравировки",
    howToAddTag: "Как добавить тег?",
    tagHowTo1: "Перейдите в редактор товара в Shopify", tagHowTo2: "Прокрутите до области \"Tags\" (теги)",
    tagHowTo3: "Добавьте нужный тег точно как показано выше", tagHowTo4: "Например: добавление \"חריטה 2\" покажет 2 поля гравировки на странице товара",
    wordsVariant: "Вариант \"Слова\" - Ценообразование по количеству слов",
    wordsVariantDesc: "Этот вариант позволяет устанавливать разные цены в зависимости от количества слов для гравировки. Система автоматически выбирает подходящий вариант.",
    noEngraving: "Без гравировки - базовая цена товара", oneWord: "Одно слово - цена за гравировку одного слова",
    twoWords: "Два слова - цена за гравировку двух слов", threeWords: "Три слова - цена за гравировку трёх слов",
    howToSetup: "Как настроить в Shopify?",
    setupStep1: "Перейдите в редактор товара в Shopify", setupStep2: "Прокрутите до области \"Variants\" (варианты)",
    setupStep3: "Добавьте новую опцию с именем", setupStep4: "Добавьте значения:",
    setupStep5: "Установите разную цену для каждого варианта (пример: 0 = ₪100, 1 = ₪120, 2 = ₪140, 3 = ₪160)",
    setupStep6: "Сохраните товар",
    quickLinks: "Быстрые ссылки на управление в Shopify", productManagement: "Управление товарами",
    addNewProduct: "Добавить новый товар", collectionManagement: "Управление коллекциями", orderManagement: "Управление заказами",
    attention: "Внимание!",
    attentionDesc: "Система автоматически выбирает вариант по количеству слов, которые клиент вводит в поле гравировки. Если варианта \"Слова\" нет, цена остаётся фиксированной.",
    usageInstructions: "Инструкция по использованию",
    usage1Title: "1. Добавление цвета к товару в Shopify",
    usage1Desc: "При добавлении варианта используйте названия цветов из списка выше. Система автоматически распознает цвет.",
    usage2Title: "2. Поддерживаемые названия цветов",
    usage2Desc: "Убедитесь что используете точные названия из списка. Например: \"Gold 14K\" а не \"Золото 14 карат\".",
    usage3Title: "3. Гравировка в заказах",
    usage3Desc: "Когда клиент заказывает товар с гравировкой, заказ содержит текст и ID шрифта. Используйте вкладку \"Шрифты\" для идентификации.",
    usage4Title: "4. Изображения вариантов",
    usage4Desc: "Рекомендуется загрузить отдельное изображение для каждого цветового варианта. Оно также отобразится в корзине.",
  },
  ar: {
    variantInfo: "معلومات المتغيرات", variantInfoDesc: "خريطة الألوان والخطوط والعلامات للاستخدام في الطلبات والمنتجات",
    colors: "ألوان", fonts: "خطوط", icons: "أيقونات", tags: "علامات", variants: "متغيرات",
    copied: "تم النسخ", copy: "نسخ", copyError: "خطأ في النسخ",
    fontsDesc: "فيما يلي قائمة خطوط النقش. عندما يختار العميل خطاً، يتم إرسال معرّف الخط إلى طلب Shopify.",
    howItWorks: "كيف يعمل؟",
    fontHowTo1: "عندما يختار العميل خطاً للنقش، يتم إرسال المعرّف (مثل: font-a) كجزء من الطلب",
    fontHowTo2: "سيحتوي طلب Shopify على حقل \"نوع الخط\" مع معرّف الخط",
    fontHowTo3: "استخدم الجدول أعلاه لتحديد الخط الذي اختاره العميل",
    iconsDesc: "فيما يلي قائمة الأيقونات المتاحة للنقش. المنتجات التي تحمل علامة \"אייקון\" ستعرض خيار اختيار أيقونة.",
    iconHowTo1: "أضف علامة \"אייקון\" للمنتج في Shopify",
    iconHowTo2: "في صفحة المنتج سيظهر خيار اختيار أيقونة للنقش",
    iconHowTo3: "ستظهر الأيقونة التي اختارها العميل في تفاصيل الطلب مع معرّفها",
    tagsDesc: "فيما يلي قائمة العلامات التي يمكن إضافتها للمنتجات في Shopify لتفعيل ميزات مختلفة في الموقع.",
    engravingTags: "علامات النقش",
    howToAddTag: "كيف تضيف علامة؟",
    tagHowTo1: "ادخل إلى محرر المنتج في Shopify", tagHowTo2: "انتقل إلى منطقة \"Tags\" (العلامات)",
    tagHowTo3: "أضف العلامة المطلوبة تماماً كما تظهر أعلاه", tagHowTo4: "مثال: إضافة \"חריטה 2\" ستعرض حقلين للنقش في صفحة المنتج",
    wordsVariant: "متغير \"كلمات\" - التسعير حسب عدد الكلمات",
    wordsVariantDesc: "يتيح هذا المتغير تحديد أسعار مختلفة بناءً على عدد الكلمات التي يدخلها العميل للنقش. يختار النظام المتغير المناسب تلقائياً.",
    noEngraving: "بدون نقش - السعر الأساسي للمنتج", oneWord: "كلمة واحدة - سعر نقش كلمة واحدة",
    twoWords: "كلمتان - سعر نقش كلمتين", threeWords: "ثلاث كلمات - سعر نقش ثلاث كلمات",
    howToSetup: "كيف تُعد في Shopify؟",
    setupStep1: "ادخل إلى محرر المنتج في Shopify", setupStep2: "انتقل إلى منطقة \"Variants\" (المتغيرات)",
    setupStep3: "أضف خياراً جديداً باسم", setupStep4: "أضف القيم:",
    setupStep5: "حدد سعراً مختلفاً لكل متغير (مثال: 0 = ₪100، 1 = ₪120، 2 = ₪140، 3 = ₪160)",
    setupStep6: "احفظ المنتج",
    quickLinks: "روابط سريعة لإدارة Shopify", productManagement: "إدارة المنتجات",
    addNewProduct: "إضافة منتج جديد", collectionManagement: "إدارة المجموعات", orderManagement: "إدارة الطلبات",
    attention: "انتبه!",
    attentionDesc: "يختار النظام المتغير تلقائياً بناءً على عدد الكلمات في حقل النقش. إذا لم يكن هناك متغير \"كلمات\"، يبقى السعر ثابتاً.",
    usageInstructions: "تعليمات الاستخدام",
    usage1Title: "1. إضافة لون لمنتج في Shopify",
    usage1Desc: "عند إضافة متغير، استخدم أسماء الألوان من القائمة أعلاه. سيتعرف النظام على اللون تلقائياً.",
    usage2Title: "2. أسماء الألوان المدعومة",
    usage2Desc: "تأكد من استخدام أسماء الألوان الدقيقة من القائمة. مثال: \"Gold 14K\" وليس \"ذهب 14 قيراط\".",
    usage3Title: "3. النقش في الطلبات",
    usage3Desc: "عند طلب منتج مع نقش، سيحتوي الطلب على النص ومعرّف الخط. استخدم تبويب \"الخطوط\" للتعرف على الخط.",
    usage4Title: "4. صور المتغيرات",
    usage4Desc: "يُنصح بتحميل صورة مخصصة لكل متغير لون. ستظهر الصورة أيضاً في سلة التسوق عند اختيار اللون.",
  },
};

// ─── Admin Search Settings ──────────────────────────────────
export const adminSearch = {
  en: {
    title: "Search Settings",
    description: "Customize the search experience on the site",
    defaultCollections: "Default Collections",
    defaultCollectionsDesc: "Products from these collections will be shown before the user starts typing",
    searchCollection: "Search collection...",
    selectedCount: (selected: number, total: number) => `${selected} collections selected out of ${total}`,
    showCategories: "Show categories in results",
    showCategoriesDesc: "Show matching categories in addition to products",
    saving: "Saving...",
    saveSettings: "Save Settings",
    savedSuccess: "Settings saved successfully",
    loadError: "Error loading settings",
    saveError: "Error saving settings",
  },
  ru: {
    title: "Настройки поиска",
    description: "Настройте поисковый опыт на сайте",
    defaultCollections: "Коллекции по умолчанию",
    defaultCollectionsDesc: "Товары из этих коллекций будут показаны до начала ввода пользователем",
    searchCollection: "Поиск коллекции...",
    selectedCount: (selected: number, total: number) => `Выбрано ${selected} коллекций из ${total}`,
    showCategories: "Показывать категории в результатах",
    showCategoriesDesc: "Показывать подходящие категории помимо товаров",
    saving: "Сохранение...",
    saveSettings: "Сохранить настройки",
    savedSuccess: "Настройки сохранены",
    loadError: "Ошибка загрузки настроек",
    saveError: "Ошибка сохранения настроек",
  },
  ar: {
    title: "إعدادات البحث",
    description: "تخصيص تجربة البحث في الموقع",
    defaultCollections: "مجموعات افتراضية",
    defaultCollectionsDesc: "ستظهر المنتجات من هذه المجموعات قبل أن يبدأ المستخدم بالكتابة",
    searchCollection: "ابحث عن مجموعة...",
    selectedCount: (selected: number, total: number) => `تم اختيار ${selected} مجموعات من ${total}`,
    showCategories: "عرض الفئات في النتائج",
    showCategoriesDesc: "عرض الفئات المطابقة بالإضافة إلى المنتجات",
    saving: "جارٍ الحفظ...",
    saveSettings: "حفظ الإعدادات",
    savedSuccess: "تم حفظ الإعدادات بنجاح",
    loadError: "خطأ في تحميل الإعدادات",
    saveError: "خطأ في حفظ الإعدادات",
  },
};

// ─── Admin Bot Settings ─────────────────────────────────────
export const adminBot = {
  en: {
    title: "Jewelry Advisor Settings",
    description: "Configure which collections belong to each target audience and product type. The bot will use this information to recommend suitable products.",
    howItWorks: "How does it work?",
    howItWorksDesc: "When a customer asks for \"bracelet for a woman\", the bot will search in the collections you defined as \"Women\" + \"Bracelets\". This prevents the bot from suggesting children's bracelets instead of adult ones.",
    noCollections: "Could not load collections from Shopify. The API token may have expired or there's a permissions issue.",
    targetAudience: "Target Audience",
    productTypes: "Product Types",
    audienceDesc: "Select which collections are suitable for each target audience. The bot will use this to suggest tailored products.",
    productTypeDesc: "Select which collections contain each product type. The bot will use this for focused search.",
    collectionsSelected: "collections selected",
    searchCollection: "Search collection...",
    noCollectionsFound: "No collections found",
    loadError: "Error loading data",
    updateError: "Error updating",
  },
  ru: {
    title: "Настройки ювелирного консультанта",
    description: "Настройте, какие коллекции принадлежат каждой целевой аудитории и типу продукта. Бот будет использовать эту информацию для рекомендации подходящих товаров.",
    howItWorks: "Как это работает?",
    howItWorksDesc: "Когда клиент просит «браслет для женщины», бот будет искать в коллекциях, которые вы определили как «Женщины» + «Браслеты». Это предотвращает предложение детских браслетов вместо взрослых.",
    noCollections: "Не удалось загрузить коллекции из Shopify. Возможно, срок действия токена API истёк или есть проблема с разрешениями.",
    targetAudience: "Целевая аудитория",
    productTypes: "Типы товаров",
    audienceDesc: "Выберите, какие коллекции подходят для каждой целевой аудитории. Бот будет использовать это для персонализированных рекомендаций.",
    productTypeDesc: "Выберите, какие коллекции содержат каждый тип товара. Бот будет использовать это для точного поиска.",
    collectionsSelected: "коллекций выбрано",
    searchCollection: "Поиск коллекции...",
    noCollectionsFound: "Коллекции не найдены",
    loadError: "Ошибка загрузки данных",
    updateError: "Ошибка обновления",
  },
  ar: {
    title: "إعدادات مستشار المجوهرات",
    description: "حدد المجموعات التي تنتمي لكل جمهور مستهدف ونوع منتج. سيستخدم البوت هذه المعلومات لتوصية المنتجات المناسبة.",
    howItWorks: "كيف يعمل؟",
    howItWorksDesc: "عندما يطلب العميل \"سوار لامرأة\"، سيبحث البوت في المجموعات التي حددتها كـ\"نساء\" + \"أساور\". هذا يمنع البوت من اقتراح أساور أطفال بدلاً من أساور بالغين.",
    noCollections: "لم نتمكن من تحميل المجموعات من Shopify. ربما انتهت صلاحية رمز API أو هناك مشكلة في الأذونات.",
    targetAudience: "الجمهور المستهدف",
    productTypes: "أنواع المنتجات",
    audienceDesc: "اختر المجموعات المناسبة لكل جمهور مستهدف. سيستخدم البوت هذا لاقتراح منتجات مخصصة.",
    productTypeDesc: "اختر المجموعات التي تحتوي على كل نوع منتج. سيستخدم البوت هذا للبحث المركّز.",
    collectionsSelected: "مجموعات مختارة",
    searchCollection: "ابحث عن مجموعة...",
    noCollectionsFound: "لم يتم العثور على مجموعات",
    loadError: "خطأ في تحميل البيانات",
    updateError: "خطأ في التحديث",
  },
};

// ─── Admin Promo Banner Settings ────────────────────────────
export const adminPromo = {
  en: {
    title: "Promo Banner Management",
    saveSettings: "Save Settings",
    enableTitle: "Enable Promo Banner",
    enableDesc: "Enable or disable the promo banner that appears above the header",
    enabled: "Promo banner is enabled",
    disabled: "Promo banner is disabled",
    bgColor: "Background Color",
    preview: "Preview",
    messagesTitle: "Promo Messages",
    messagesDesc: "Add messages to display in the promo banner. Drag to reorder.",
    addMessage: "Add Message",
    noMessages: "No messages defined yet",
    noMessagesHint: "Click \"Add Message\" to start",
    messageText: "Message Text",
    messagePlaceholder: "Free shipping on orders over ₪500!",
    linkLabel: "Link (optional)",
    linkPlaceholder: "/category/sale or https://...",
    active: "Active",
    inactive: "Inactive",
    savedSuccess: "Settings saved successfully",
    loadError: "Error loading data",
    saveError: "Error saving settings",
    addedSuccess: "New message added",
    addError: "Error adding message",
    deletedSuccess: "Message deleted",
    deleteError: "Error deleting message",
  },
  ru: {
    title: "Управление промо-баннером",
    saveSettings: "Сохранить настройки",
    enableTitle: "Включить промо-баннер",
    enableDesc: "Включите или выключите промо-баннер, отображаемый над шапкой",
    enabled: "Промо-баннер включён",
    disabled: "Промо-баннер выключен",
    bgColor: "Цвет фона",
    preview: "Предпросмотр",
    messagesTitle: "Промо-сообщения",
    messagesDesc: "Добавьте сообщения для промо-баннера. Перетаскивайте для изменения порядка.",
    addMessage: "Добавить сообщение",
    noMessages: "Сообщения ещё не настроены",
    noMessagesHint: "Нажмите \"Добавить сообщение\" чтобы начать",
    messageText: "Текст сообщения",
    messagePlaceholder: "Бесплатная доставка при заказе от ₪500!",
    linkLabel: "Ссылка (необязательно)",
    linkPlaceholder: "/category/sale или https://...",
    active: "Активно",
    inactive: "Неактивно",
    savedSuccess: "Настройки сохранены",
    loadError: "Ошибка загрузки данных",
    saveError: "Ошибка сохранения настроек",
    addedSuccess: "Новое сообщение добавлено",
    addError: "Ошибка добавления сообщения",
    deletedSuccess: "Сообщение удалено",
    deleteError: "Ошибка удаления сообщения",
  },
  ar: {
    title: "إدارة شريط العروض",
    saveSettings: "حفظ الإعدادات",
    enableTitle: "تفعيل شريط العروض",
    enableDesc: "تفعيل أو تعطيل شريط العروض الذي يظهر فوق الترويسة",
    enabled: "شريط العروض مفعّل",
    disabled: "شريط العروض معطّل",
    bgColor: "لون الخلفية",
    preview: "معاينة",
    messagesTitle: "رسائل العروض",
    messagesDesc: "أضف رسائل لعرضها في شريط العروض. اسحب لإعادة الترتيب.",
    addMessage: "إضافة رسالة",
    noMessages: "لم يتم تحديد رسائل بعد",
    noMessagesHint: "اضغط على \"إضافة رسالة\" للبدء",
    messageText: "نص الرسالة",
    messagePlaceholder: "شحن مجاني للطلبات فوق ₪500!",
    linkLabel: "رابط (اختياري)",
    linkPlaceholder: "/category/sale أو https://...",
    active: "نشط",
    inactive: "غير نشط",
    savedSuccess: "تم حفظ الإعدادات بنجاح",
    loadError: "خطأ في تحميل البيانات",
    saveError: "خطأ في حفظ الإعدادات",
    addedSuccess: "تمت إضافة رسالة جديدة",
    addError: "خطأ في إضافة الرسالة",
    deletedSuccess: "تم حذف الرسالة",
    deleteError: "خطأ في حذف الرسالة",
  },
};

// ─── Admin FAQ Settings ─────────────────────────────────────
export const adminFaq = {
  en: {
    manageDesc: "Manage the FAQ displayed on the site",
    newCategory: "New Category",
    newQuestion: "New Question",
    editCategory: "Edit Category",
    addCategory: "Add Category",
    categoryName: "Category Name",
    categoryPlaceholder: "e.g.: General Questions",
    update: "Update",
    add: "Add",
    questions: "questions",
    inactive: "Inactive",
    category: "Category",
    selectCategory: "Select category",
    theQuestion: "Question",
    questionPlaceholder: "Enter the question",
    theAnswer: "Answer",
    answerPlaceholder: "Enter the answer",
    noCategories: "No categories yet. Click \"New Category\" to add the first one.",
    noQuestionsInCategory: "No questions in this category",
    addQuestionToCategory: "Add question to this category",
    enterCategoryName: "Please enter a category name",
    fillAllFields: "Please fill in all fields",
    categoryAdded: "Category added successfully",
    categoryUpdated: "Category updated successfully",
    categorySaveError: "Error saving category",
    categoryDeleted: "Category deleted successfully",
    categoryDeleteError: "Error deleting category",
    categoryToggleError: "Error updating category",
    questionAdded: "Question added successfully",
    questionUpdated: "Question updated successfully",
    questionSaveError: "Error saving question",
    questionDeleted: "Question deleted successfully",
    questionDeleteError: "Error deleting question",
    questionToggleError: "Error updating question",
    loadError: "Error loading data",
  },
  ru: {
    manageDesc: "Управление часто задаваемыми вопросами на сайте",
    newCategory: "Новая категория",
    newQuestion: "Новый вопрос",
    editCategory: "Редактировать категорию",
    addCategory: "Добавить категорию",
    categoryName: "Название категории",
    categoryPlaceholder: "например: Общие вопросы",
    update: "Обновить",
    add: "Добавить",
    questions: "вопросов",
    inactive: "Неактивно",
    category: "Категория",
    selectCategory: "Выберите категорию",
    theQuestion: "Вопрос",
    questionPlaceholder: "Введите вопрос",
    theAnswer: "Ответ",
    answerPlaceholder: "Введите ответ",
    noCategories: "Категорий пока нет. Нажмите \"Новая категория\" чтобы добавить первую.",
    noQuestionsInCategory: "В этой категории нет вопросов",
    addQuestionToCategory: "Добавить вопрос в эту категорию",
    enterCategoryName: "Введите название категории",
    fillAllFields: "Заполните все поля",
    categoryAdded: "Категория добавлена",
    categoryUpdated: "Категория обновлена",
    categorySaveError: "Ошибка сохранения категории",
    categoryDeleted: "Категория удалена",
    categoryDeleteError: "Ошибка удаления категории",
    categoryToggleError: "Ошибка обновления категории",
    questionAdded: "Вопрос добавлен",
    questionUpdated: "Вопрос обновлён",
    questionSaveError: "Ошибка сохранения вопроса",
    questionDeleted: "Вопрос удалён",
    questionDeleteError: "Ошибка удаления вопроса",
    questionToggleError: "Ошибка обновления вопроса",
    loadError: "Ошибка загрузки данных",
  },
  ar: {
    manageDesc: "إدارة الأسئلة الشائعة المعروضة على الموقع",
    newCategory: "فئة جديدة",
    newQuestion: "سؤال جديد",
    editCategory: "تعديل الفئة",
    addCategory: "إضافة فئة",
    categoryName: "اسم الفئة",
    categoryPlaceholder: "مثال: أسئلة عامة",
    update: "تحديث",
    add: "إضافة",
    questions: "أسئلة",
    inactive: "غير نشط",
    category: "الفئة",
    selectCategory: "اختر فئة",
    theQuestion: "السؤال",
    questionPlaceholder: "أدخل السؤال",
    theAnswer: "الإجابة",
    answerPlaceholder: "أدخل الإجابة",
    noCategories: "لا توجد فئات بعد. اضغط على \"فئة جديدة\" لإضافة الأولى.",
    noQuestionsInCategory: "لا توجد أسئلة في هذه الفئة",
    addQuestionToCategory: "إضافة سؤال لهذه الفئة",
    enterCategoryName: "يرجى إدخال اسم الفئة",
    fillAllFields: "يرجى ملء جميع الحقول",
    categoryAdded: "تمت إضافة الفئة بنجاح",
    categoryUpdated: "تم تحديث الفئة بنجاح",
    categorySaveError: "خطأ في حفظ الفئة",
    categoryDeleted: "تم حذف الفئة بنجاح",
    categoryDeleteError: "خطأ في حذف الفئة",
    categoryToggleError: "خطأ في تحديث الفئة",
    questionAdded: "تمت إضافة السؤال بنجاح",
    questionUpdated: "تم تحديث السؤال بنجاح",
    questionSaveError: "خطأ في حفظ السؤال",
    questionDeleted: "تم حذف السؤال بنجاح",
    questionDeleteError: "خطأ في حذف السؤال",
    questionToggleError: "خطأ في تحديث السؤال",
    loadError: "خطأ في تحميل البيانات",
  },
};

// ─── Admin Contact Messages ─────────────────────────────────
export const adminContact = {
  en: {
    loading: "Loading messages...",
    noMessages: "No messages to display",
    status: "Status",
    name: "Name",
    email: "Email",
    phone: "Phone",
    message: "Message",
    date: "Date",
    actions: "Actions",
    new: "New",
    handled: "Handled",
    notAvailable: "N/A",
    markedHandled: "Message marked as handled",
    markedNew: "Message marked as new",
    statusError: "Error updating status",
    deleted: "Message deleted successfully",
    deleteError: "Error deleting message",
    loadError: "Error loading messages",
  },
  ru: {
    loading: "Загрузка сообщений...",
    noMessages: "Нет сообщений для отображения",
    status: "Статус",
    name: "Имя",
    email: "Email",
    phone: "Телефон",
    message: "Сообщение",
    date: "Дата",
    actions: "Действия",
    new: "Новое",
    handled: "Обработано",
    notAvailable: "Н/Д",
    markedHandled: "Сообщение отмечено как обработанное",
    markedNew: "Сообщение отмечено как новое",
    statusError: "Ошибка обновления статуса",
    deleted: "Сообщение удалено",
    deleteError: "Ошибка удаления сообщения",
    loadError: "Ошибка загрузки сообщений",
  },
  ar: {
    loading: "جارٍ تحميل الرسائل...",
    noMessages: "لا توجد رسائل للعرض",
    status: "الحالة",
    name: "الاسم",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    message: "الرسالة",
    date: "التاريخ",
    actions: "إجراءات",
    new: "جديد",
    handled: "تمت المعالجة",
    notAvailable: "غير متوفر",
    markedHandled: "تم تحديد الرسالة كمعالجة",
    markedNew: "تم تحديد الرسالة كجديدة",
    statusError: "خطأ في تحديث الحالة",
    deleted: "تم حذف الرسالة بنجاح",
    deleteError: "خطأ في حذف الرسالة",
    loadError: "خطأ في تحميل الرسائل",
  },
};

// ─── Admin Customer Messages ────────────────────────────────
export const adminCustomerMsg = {
  en: {
    sendTitle: "Send New Message",
    selectCustomer: "Select Customer",
    selectCustomerPlaceholder: "Select customer...",
    searchCustomer: "Search customer...",
    unknownCustomer: "Unknown Customer",
    subject: "Subject",
    subjectPlaceholder: "Message subject...",
    messageContent: "Message Content",
    messagePlaceholder: "Write the message...",
    attachment: "Attachment (optional)",
    addFile: "Add File",
    sending: "Sending...",
    sendMessage: "Send Message",
    historyTitle: "Message History",
    noMessages: "No messages yet",
    to: "To:",
    unread: "Unread",
    sentAt: "Sent at:",
    attachedFile: "Attached file",
    fileTooLarge: "File too large. Maximum 10MB",
    fillAllFields: "Please fill in all fields",
    sentSuccess: "Message sent successfully!",
    sendError: "Error sending message",
    deleteTitle: "Delete Message",
    deleteDesc: "Are you sure you want to delete this message? This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
    deleted: "Message deleted",
    deleteError: "Error deleting message",
    loadError: "Error loading data",
  },
  ru: {
    sendTitle: "Отправить новое сообщение",
    selectCustomer: "Выберите клиента",
    selectCustomerPlaceholder: "Выберите клиента...",
    searchCustomer: "Поиск клиента...",
    unknownCustomer: "Неизвестный клиент",
    subject: "Тема",
    subjectPlaceholder: "Тема сообщения...",
    messageContent: "Содержание сообщения",
    messagePlaceholder: "Напишите сообщение...",
    attachment: "Вложение (необязательно)",
    addFile: "Добавить файл",
    sending: "Отправка...",
    sendMessage: "Отправить сообщение",
    historyTitle: "История сообщений",
    noMessages: "Сообщений пока нет",
    to: "Кому:",
    unread: "Не прочитано",
    sentAt: "Отправлено:",
    attachedFile: "Прикреплённый файл",
    fileTooLarge: "Файл слишком большой. Максимум 10МБ",
    fillAllFields: "Заполните все поля",
    sentSuccess: "Сообщение отправлено!",
    sendError: "Ошибка отправки сообщения",
    deleteTitle: "Удалить сообщение",
    deleteDesc: "Вы уверены, что хотите удалить это сообщение? Это действие необратимо.",
    cancel: "Отмена",
    delete: "Удалить",
    deleted: "Сообщение удалено",
    deleteError: "Ошибка удаления сообщения",
    loadError: "Ошибка загрузки данных",
  },
  ar: {
    sendTitle: "إرسال رسالة جديدة",
    selectCustomer: "اختر عميل",
    selectCustomerPlaceholder: "اختر عميل...",
    searchCustomer: "بحث عن عميل...",
    unknownCustomer: "عميل غير معروف",
    subject: "الموضوع",
    subjectPlaceholder: "موضوع الرسالة...",
    messageContent: "محتوى الرسالة",
    messagePlaceholder: "اكتب الرسالة...",
    attachment: "مرفق (اختياري)",
    addFile: "إضافة ملف",
    sending: "جارٍ الإرسال...",
    sendMessage: "إرسال رسالة",
    historyTitle: "سجل الرسائل",
    noMessages: "لا توجد رسائل بعد",
    to: "إلى:",
    unread: "غير مقروءة",
    sentAt: "أُرسلت في:",
    attachedFile: "ملف مرفق",
    fileTooLarge: "الملف كبير جداً. الحد الأقصى 10 ميجابايت",
    fillAllFields: "يرجى ملء جميع الحقول",
    sentSuccess: "تم إرسال الرسالة بنجاح!",
    sendError: "خطأ في إرسال الرسالة",
    deleteTitle: "حذف الرسالة",
    deleteDesc: "هل أنت متأكد من حذف هذه الرسالة؟ لا يمكن التراجع عن هذا الإجراء.",
    cancel: "إلغاء",
    delete: "حذف",
    deleted: "تم حذف الرسالة",
    deleteError: "خطأ في حذف الرسالة",
    loadError: "خطأ في تحميل البيانات",
  },
};

// ─── Admin SMS Templates ────────────────────────────────────
export const adminSms = {
  en: {
    title: "Edit SMS Messages",
    description: "Edit the SMS message templates sent to customers on each status change",
    updated: "Updated:",
    chars: "characters",
    save: "Save",
    noTemplates: "No SMS templates found",
    availableVars: "Available variables:",
    var1: "The ticket number will appear automatically at the beginning",
    var2: "The ticket title will appear automatically",
    var3: "A link to the personal area will appear at the end",
    noChanges: "No changes made",
    savedSuccess: "Template updated successfully",
    saveError: "Error saving template",
    loadError: "Error loading SMS templates",
    placeholder: "Enter message content...",
    pending: "Pending",
    in_repair: "In Repair",
    completed: "Completed",
    waiting_in_store: "Waiting in Store",
    shipped: "Shipped",
    delivered: "Delivered",
    cancelled: "Cancelled",
  },
  ru: {
    title: "Редактирование SMS-сообщений",
    description: "Редактируйте шаблоны SMS-сообщений, отправляемых клиентам при изменении статуса",
    updated: "Обновлено:",
    chars: "символов",
    save: "Сохранить",
    noTemplates: "Шаблоны SMS не найдены",
    availableVars: "Доступные переменные:",
    var1: "Номер заявки появится автоматически в начале",
    var2: "Заголовок заявки появится автоматически",
    var3: "Ссылка на личный кабинет появится в конце",
    noChanges: "Изменений нет",
    savedSuccess: "Шаблон обновлён",
    saveError: "Ошибка сохранения шаблона",
    loadError: "Ошибка загрузки шаблонов SMS",
    placeholder: "Введите текст сообщения...",
    pending: "Ожидает",
    in_repair: "В ремонте",
    completed: "Завершено",
    waiting_in_store: "Ожидает в магазине",
    shipped: "Отправлено",
    delivered: "Доставлено",
    cancelled: "Отменено",
  },
  ar: {
    title: "تعديل رسائل SMS",
    description: "تعديل قوالب رسائل SMS المرسلة للعملاء عند كل تغيير حالة",
    updated: "تم التحديث:",
    chars: "أحرف",
    save: "حفظ",
    noTemplates: "لم يتم العثور على قوالب SMS",
    availableVars: "المتغيرات المتاحة:",
    var1: "سيظهر رقم الطلب تلقائياً في البداية",
    var2: "سيظهر عنوان الطلب تلقائياً",
    var3: "سيظهر رابط المنطقة الشخصية في النهاية",
    noChanges: "لم يتم إجراء تغييرات",
    savedSuccess: "تم تحديث القالب بنجاح",
    saveError: "خطأ في حفظ القالب",
    loadError: "خطأ في تحميل قوالب SMS",
    placeholder: "أدخل محتوى الرسالة...",
    pending: "قيد الانتظار",
    in_repair: "قيد الإصلاح",
    completed: "مكتمل",
    waiting_in_store: "في انتظار بالمتجر",
    shipped: "تم الشحن",
    delivered: "تم التسليم",
    cancelled: "ملغى",
  },
};

// ─── Admin TV Display Settings ──────────────────────────────
export const adminTV = {
  en: {
    title: "Store Display Settings (TV)",
    openDisplay: "Open Display",
    tvLink: "TV display link:",
    generalSettings: "General Settings",
    activeDisplay: "Active Display",
    showPrices: "Show Prices",
    showVariants: "Show Variants",
    slideDuration: "Display time per product (seconds)",
    categoriesToShow: "Categories to Display",
    categoriesDesc: "Select specific categories. If none selected, all products will be shown.",
    selectCategory: "Select category...",
    removeSale: "Remove Sale",
    markAsSale: "Mark as Sale",
    saleText: "Sale Text",
    salePlaceholder: "e.g.: End of Season Sale!",
    saleEndTime: "Sale End (date and time)",
    promoMessages: "Promo Messages",
    promoDesc: "Messages that will run in the ticker at the bottom of the screen (like a news ticker).",
    promoPlaceholder: "e.g.: 20% off all rings this week!",
    saving: "Saving...",
    saveSettings: "Save Settings",
    savedSuccess: "TV display settings saved successfully",
    saveError: "Error saving settings",
  },
  ru: {
    title: "Настройки витрины (ТВ)",
    openDisplay: "Открыть витрину",
    tvLink: "Ссылка на ТВ-витрину:",
    generalSettings: "Общие настройки",
    activeDisplay: "Активная витрина",
    showPrices: "Показывать цены",
    showVariants: "Показывать варианты",
    slideDuration: "Время показа товара (секунды)",
    categoriesToShow: "Категории для отображения",
    categoriesDesc: "Выберите конкретные категории. Если не выбрано ни одной, будут показаны все товары.",
    selectCategory: "Выберите категорию...",
    removeSale: "Убрать акцию",
    markAsSale: "Отметить как акцию",
    saleText: "Текст акции",
    salePlaceholder: "например: Распродажа конца сезона!",
    saleEndTime: "Окончание акции (дата и время)",
    promoMessages: "Промо-сообщения",
    promoDesc: "Сообщения, которые будут бегущей строкой внизу экрана (как новостная лента).",
    promoPlaceholder: "например: Скидка 20% на все кольца на этой неделе!",
    saving: "Сохранение...",
    saveSettings: "Сохранить настройки",
    savedSuccess: "Настройки ТВ-витрины сохранены",
    saveError: "Ошибка сохранения настроек",
  },
  ar: {
    title: "إعدادات شاشة العرض (TV)",
    openDisplay: "فتح العرض",
    tvLink: "رابط شاشة العرض:",
    generalSettings: "إعدادات عامة",
    activeDisplay: "العرض نشط",
    showPrices: "عرض الأسعار",
    showVariants: "عرض المتغيرات",
    slideDuration: "مدة العرض لكل منتج (ثوانٍ)",
    categoriesToShow: "فئات للعرض",
    categoriesDesc: "اختر فئات محددة. إذا لم يتم اختيار أي فئة، ستُعرض جميع المنتجات.",
    selectCategory: "اختر فئة...",
    removeSale: "إزالة العرض",
    markAsSale: "تحديد كعرض",
    saleText: "نص العرض",
    salePlaceholder: "مثال: تخفيضات نهاية الموسم!",
    saleEndTime: "انتهاء العرض (تاريخ ووقت)",
    promoMessages: "رسائل ترويجية",
    promoDesc: "رسائل ستظهر في شريط أسفل الشاشة (مثل شريط الأخبار).",
    promoPlaceholder: "مثال: خصم 20% على جميع الخواتم هذا الأسبوع!",
    saving: "جارٍ الحفظ...",
    saveSettings: "حفظ الإعدادات",
    savedSuccess: "تم حفظ إعدادات شاشة العرض بنجاح",
    saveError: "خطأ في حفظ الإعدادات",
  },
};
